import {
  DimensionDescriptor,
  CalculateByField,
  NumberFormatterOptions,
  AmountType,
} from "../../../../../../shared/reporting/api/biClient.types";
import { FunctionDescription, MeasureDataset } from "../../../../../api/biApi.types";
import { FormulaNode } from "../utilities/fillNodes";
import { INode } from "../utilities/formulaParser";
import { Token } from "../utilities/tokenizer";

export type CustomMeasureState = {
  rootNode?: INode;
  formulaNodes: FormulaNode[];
  dimensions: DimensionDescriptor[];
  functions: FunctionDescription[];
  currentToken?: Token;
  caption?: string;
  group?: string;
  calculateBy?: CalculateByField;
  formula?: string;
  format?: NumberFormatterOptions;
  functionHovered?: Token | undefined;
  selectedFormulaParameter?: Token | undefined;
  amountType?: AmountType;
  nodesCounter?: NodesCounter;
  dataSets: MeasureDataset[];
  isConfigurable?: boolean;
};

export type NodesCounter = {
  nodeVariable: number;
  nodeFunction: number;
  nodeNumber: number;
};

export const initialState: CustomMeasureState = {
  formulaNodes: [],
  dimensions: [],
  functions: [],
  caption: "",
  calculateBy: CalculateByField.Lcy,
  amountType: AmountType.Net,
  dataSets: [],
};
